import { Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuVerticalDividerComponent } from '../../../shared/components/menu-vertical-divider.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'lfw-order-editor-mobile-menu',
  templateUrl: './order-editor-mobile-menu.component.html',
  styleUrls: ['./order-editor-mobile-menu.component.css'],
  imports: [
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    TranslatePipe,
    MenuVerticalDividerComponent,
    MatTooltip
  ]
})
export class OrderEditorMobileMenuComponent {
  canSave = input<boolean>(true);
  canFinalize = input<boolean>(true);
  canClose = input<boolean>(true);
  tooltipForFinalizeButton = input<string>();

  readonly save = output<void>();
  readonly finalize = output<void>();
  readonly closeForm = output<void>();
}
